import React from 'react';
import EXTRA_COMPONENT_TYPE from '@modules/questionnaires/extraComponent/extraComponentType';
import LinkToLeSubsidiaries from '@modules/questionnaires/extraComponent/LinkToLeSubsidiaries/LinkToLeSubsidiaries';
import HeadcountTable from '@modules/questionnaires/extraComponent/HeadcountTable/HeadcountTable';

const COMPONENT_MAP = {
  [EXTRA_COMPONENT_TYPE.LinkToLESubsidiaries]: LinkToLeSubsidiaries,
  [EXTRA_COMPONENT_TYPE.HeadcountTable]: HeadcountTable,
};

function renderExtra(type) {
  const ExtraComponent = COMPONENT_MAP[type] || null;
  return ExtraComponent ? <ExtraComponent /> : null;
}

export default renderExtra;
